import { render } from "./InputSlug.vue?vue&type=template&id=508c39dd"
import script from "./InputSlug.vue?vue&type=script&lang=js"
export * from "./InputSlug.vue?vue&type=script&lang=js"
script.render = render

export default script